import React from 'react';
import TooltipWrapper from '../../../../../common/components/Form/TooltipWrapper';

export function ConfigurationTooltipWrapper({ trigger, message }) {
  return (
    <TooltipWrapper
      hideHighlight
      position="top"
      tip={<span>{message}</span>}
    >
      {trigger}
    </TooltipWrapper>
  );
}
